export default __webpack_public_path__ + "static/media/details-2.dc89255d.jpg";